const SEND_MESSAGE = 'samurai-network/dialogs/SEND-MESSAGE';

let initialState = {
    dialogs: [
        {id: 1, name: 'Dimych'},
        {id: 2, name: 'Andrey'},
        {id: 3, name: 'Sveta'},
        {id: 4, name: 'Sasha'},
        {id: 5, name: 'Viktor'},
        {id: 6, name: 'Valera'},
    ] as Array<DialogsType>,
    messages: [
        {id: 1, message: 'Hi'},
        {id: 2, message: 'How are you?'},
        {id: 3, message: 'Yo'},
        {id: 4, message: 'Yo'},
        {id: 5, message: 'Yo'},
        {id: 6, message: 'Hey'},
    ] as Array<MessagesType>
}

const dialogsReducer = (state: DialogsPageType = initialState, action: DialogsActionsTypes): DialogsPageType => {
    switch (action.type) {
        case SEND_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, {id: Math.random(), message: action.newMessageBody}]
            }
        default:
            return state;
    }
}

//AC
export const sendMessageCreator = (newMessageBody: string) => ({type: SEND_MESSAGE, newMessageBody}) as const

//types
type DialogsType = {
    id: number
    name: string
}
type MessagesType = {
    id: number
    message: string
}

export type DialogsActionsTypes = ReturnType<typeof sendMessageCreator>

export type DialogsPageType = typeof initialState

export default dialogsReducer;